<template lang="pug">
v-card(class='section-card')
  v-card-title(class='pb-0')
    v-container(class='pa-0')
      v-layout( :class='{"hidden": section.hidden}')
        v-flex
          div(class='subheading font-weight-bold text-truncate')
            | {{ section.section_name }}
          div(v-if='section.min_floor || section.max_floor' class='grey--text')
            | Этажи с {{ section.min_floor }} по {{ section.max_floor }}
          div(v-else class='grey--text') Не задан min и max этажа
        v-menu(light)
          v-btn(slot='activator' icon)
            v-icon more_vert
          v-list
            v-list-tile(@click='$emit("editSection", section)')
              v-list-tile-action
                v-icon edit
              v-list-tile-content
                v-list-tile-title Редактировать подъезд
            v-list-tile(@click='$emit("removeSection", section)')
              v-list-tile-action
                v-icon delete
              v-list-tile-content
                v-list-tile-title Удалить подъезд
  v-card-text(class='pt-0')
    v-card(
      v-for='(floor, key) in floors'
      :color='getFloorColor(floor)'
      :key='key'
      @mouseleave='onMouseLeave(key)'
      class='my-2 floor'
      flat
    )
      div(@mouseenter='onMouseEnter(key)')
        v-list(class='floor-row' two-line dense)
          v-list-tile(
            @click='$emit("editFloor", { section, floor })'
            class='floor-row'
          )
            v-list-tile-avatar(color='white' size='36' dark)
              div(class='flat')
                div(class='flat-num') {{ key }}
                div(class='flat-tit') эт
            v-list-tile-content
              v-list-tile-sub-title
                span(v-if='floor.placements_count') На этаже {{ floor.placements_count }} кв.
                span(v-else) Нет квартир
              v-list-tile-sub-title
                //- v-icon(small) format_shapes
                //- | {{ floor.floor_scheme_url ? "схема загружена"  : "" }}
            v-list-tile-action
              v-btn(@click.stop='$emit("removeFloor", floor)' flat icon small)
                v-icon(small) delete_outline
  v-card-text
    v-btn(
      v-show='totalFloors - 1 < section.max_floor - section.min_floor'
      :ripple='false'
      @click.stop='$emit("addFloor", { section })'
      color='primary'
      style='display: none'
      outline
      block
    )
      v-icon(left small) add
      | Добавить этаж
</template>

<script>
export default {
  name: 'Card',
  props: ['section', 'sectionIndex'],

  data: () => ({
    floors: []
  }),

  mounted() {
    this.setFloors()
  },

  methods: {
    setFloors() {
      this.floors = this.section.floors.reduce((acc, floor, i) => {
        floor.floor_numbers_array.forEach(fln => {
          acc[fln] = { ...floor, colorIndex: i, active: false }
        })
        return acc
      }, {})
    },

    getFloorColor({ active }) {
      return active ? 'orange lighten-5' : 'grey lighten-4'
    },

    onMouseEnter(key) {
      this.toggleActive(key, true)
    },

    onMouseLeave(key) {
      this.toggleActive(key, false)
    },

    toggleActive(key, active) {
      let similar = this.floors[key].floor_numbers_array
      similar.forEach(s => (this.floors[s].active = active))
    }
  },

  computed: {
    totalFloors() {
      let { floors = [] } = this.section
      return floors.reduce((acc, f) => {
        return acc + f.floor_numbers_array.length
      }, 0)
    }
  },

  watch: {
    section: {
      deep: true,
      handler: 'setFloors'
    }
  }
}
</script>

<style scoped>
.section-card {
  width: 280px;
}
.section-card >>> .v-card__text {
  padding-top: 8px;
  padding-bottom: 8px;
}
.floor {
  cursor: pointer;
  transition: all 0.25s;
}
.card-actions {
  cursor: pointer;
  background: #fff3e0;
}
.card-actions >>> .v-btn:before,
.card-actions >>> .v-btn:after {
  display: none;
}
.floor >>> .v-btn {
  display: none;
}
.floor >>> .v-list {
  background: none;
  padding: 0;
}
.floor >>> .v-btn >>> * {
  transition: none !important;
}
.floor:hover >>> .v-btn {
  display: block;
}
.floor >>> .v-list__tile--link:hover {
  background: none;
}
.flat {
  line-height: 1;
}
.flat-tit {
  opacity: 0.5;
  font-size: 10px;
  margin-top: -2px;
}
.flat-num {
  opacity: 0.75;
  font-size: 15px;
  font-weight: 800;
}
.hidden .subheading {
  color: #9e9e9e;
}
</style>
